import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

const CREATE_ROLE = gql`mutation createRole($input: ABMRoleInput) {
  createRole(input: $input) {
    id
    name
    roleName
    resources
  }
}
`
const CreateRole = ({ children, ...props }) => {
  return (
    <MutationManager mutation={CREATE_ROLE} refetchQueries={['getResources']}>
      {({ data, loading, client, updateFn }) => children({ updateFn, client, loading, ...props })}
    </MutationManager>
  )
}

CreateRole.propTypes = {
  children: PropTypes.any
}

export default CreateRole
